export default __webpack_public_path__ + "static/media/frenzystance.227428e0.png";